import "./OpenTraderVideosComponent.scss";

import {IComponentOptions} from "angular";
import template from "./OpenTraderVideosComponent.html";

export const OpenTraderVideos = "tfOpenTraderVideos";

export function openTraderVideos(): IComponentOptions {
    return {
        template,
        bindings: {
        },
        controllerAs: "ctrl",
        controller: OpenTraderVideosComponentController
    };
}

export class OpenTraderVideosComponentController {

}